export const menuData = [
    { title: 'The Cabin', link: '/yadkinvalleywinecountry' },
    { title: 'Lodging', link: '/littleheavenbedandbreakfast' },
    { title: 'Cafe', link: '/breakfast' },
    { title: 'Weddings', link: '/weddings' },
    { title: 'Packages', link: '/packages' },
    { title: 'The Area', link: '/thearea' },
    { title: 'Special Events', link: '/specialevents' },
    { title: 'Our Story', link: '/story' },
]